angular
	.module 'App.Repository'
	.factory 'PurchaseOrderReportRepository', ['BaseRepository', (BaseRepository) ->
		class PurchaseOrderReportRepository extends BaseRepository
			@resource = '/reports/purchase_orders'
			@isRestricted = true

		return new PurchaseOrderReportRepository
	]
